import { essaysPolicies } from '@/features/essays/policies';
import { dashboardPolicies } from '@/features/home-manager/policies';
import { learningPathPolicies } from '@/features/learning-path/policies';
import { taskCreationPolicies } from '@/features/task-creation/policies';

import type { Policy, PolicyName, UserWithContext } from './types';

const policies: Policy<unknown>[] = [
  ...dashboardPolicies,
  ...essaysPolicies,
  ...learningPathPolicies,
  ...taskCreationPolicies,
  // Adicionar policies aqui ao criar cada feature:
];

export function isAuthorized(user: UserWithContext, name: PolicyName, resource?: unknown): boolean {
  const policy = policies.find((p) => p.name === name);

  if (!policy) {
    if (import.meta.env.DEV) {
      console.error(`[permissions] Policy "${name}" não encontrada. Registrada em permissions/index.ts?`);
    }
    throw new Error(`[permissions] Policy "${name}" não encontrada.`);
  }

  return policy.evaluate({ user, resource });
}

export { requireAccess, requireAuthenticated } from './routeGuard';
export type { PolicyName, UserWithContext } from './types';
